import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent {
  @Input() title: string;
  @Input() icon: string;
  @Input() favorite = false;
  @Input() isActive = true;
  @Input() showFavorite = true;

  @Output() readonly favoriteEvent = new EventEmitter<boolean>();

  setFavorite() {
    this.favoriteEvent.emit(!this.favorite);
  }

  setIcon() {
    return this.favorite ? faStar : faStarRegular;
  }
}